// extracted by mini-css-extract-plugin
module.exports = {"root":"PendingPaymentAlert_root__1Aw4S","buttons":"PendingPaymentAlert_buttons__3uqc5"};